export const isCurrentDealerPath = (currentPath, menuPath) => {
    if (menuPath === '/teenindus' && (currentPath === '/' || currentPath === '/teenindus')) {
        return true;
    }
    const menuPathWithoutService = menuPath.startsWith('/teenindus') ? menuPath.replace('/teenindus', '') : menuPath;
    const currentPathWithoutService = currentPath.startsWith('/teenindus') ? currentPath.replace('/teenindus', '') : currentPath;
    return !!menuPathWithoutService && currentPathWithoutService.startsWith(menuPathWithoutService);
};
//# sourceMappingURL=MenuItemUtil.js.map